/*Halado_5_1 3:21 */
import React from 'react'

export default function AboutPage() {
  return (
    <div className='szilvia-container'>

      <h1>Szilvia szelet</h1>

      <p>Ez egy tipikus lakodalmas süti, cuppanós krémmel. Egy kicsit macerás az elkészítése a lapok miatt, de a krém már egyszerű és a végeredmény megéri.</p>
    
    <div className='text-with-columns'>
        <div className='column1'>
      

        <h2>Hozzávalók:</h2>

        <h2>Tésztához:</h2>

        <ul>
        <li>2 evőkanál méz</li>
        <li>10 dkg cukor</li>
        <li>5 dkg margarin (vagy vaj)</li>
        <li>2 tojás</li>
        <li>40 dkg finomliszt</li>
        <li>1 kávéskanál szódabikarbóna</li>
        </ul>

        <h2>Krémhez:</h2>

        <ul>
        <li>0,5 liter zsíros tej</li>
        <li>8 evőkanál rétesliszt (ha nincs finomliszt is jó)</li>
        <li>20 dkg porcukor</li>
        <li>20 dkg margarin (vagy vaj)</li>
        <li>40 dkg finomliszt</li>
        <li>2 evőkanál cukrozatlan kakaópor</li>
        <li>1 csomag vaníliás cukor</li>
        </ul>
    
        </div>
        <div className='column2'>

        <h2>Elkészítése:</h2>
        <p>Először süssük meg a lapokat. Ha ezt kibírtuk idegekkel, akkor már gyerekjáték lesz. Azért macerás egy kicsit, mert ugyan a tésztát könnyű összeállítani, de a nyújtása nehézkes egy cseppet.</p>

        <p>Egy edényben langyosítsuk meg a mézet, majd tegyük bele a margarint olvasszuk fel, majd a két tojást is kavarjuk el benne. Vigyázzunk, nehogy tojásrántotta legyen belőle! Ha megkaptuk a szép, homogén anyagunkat, akkor öntsük hozzá a szódabikarbónás liszthez és dolgozzuk össze. Előbb a fakanállal, amivel az alapot is kavargattuk, majd kézzel folytatva, hogy a tészta összeálljon.</p>

        <p>A kész tésztát három részre osztjuk, majd vékonyan tepsi méretűre nyújtjuk. A nyújtáskor a deszkát lisztezni kell, hogy ne ragadjon le, a szélei pedig repedeznek erőteljesen, de ez ne szegje kedvünket. Akinek úgy tetszik megsütheti a tepsi hátán, én sütőpapírral bélelt tepsiben szoktam. A sütőt 190 °C-ra melegítem légkeveréssel (gázon közepesnél nagyobb fokozat), amelyben 3-5 perc alatt megsül a tészta. Világos színűre süssük, nem kell kiszárítani. mielőtt betesszük a tésztát érdemes villával megszurkálni, így nem fog felpúposodni sütéskor. Kész tésztalapokat hagyjuk kihűlni.</p>

        <p>Elkészítjük a krémet. Két színű krémre van szükségünk. Először a lisztet csomómentesen elkeverjük a tejben, majd felforraljuk és addig főzzük, míg besűrűsödik. Vigyázzunk, hogy nehogy csomós legyen. Réteslisztet könnyebb csomómentesre keverni, de a finomliszt is jó, ha az van otthon. Ha ez kész, akkor hagyjuk szobahőmérsékletűre hűlni.</p>

        <p>A porcukrot elkeverjük a margarinnal (vajjal), majd a főzött alapot belekeverjük és alaposan eldolgozzuk. A kész krémnek kivesszük a felét, majd az egyik felébe beledolgozzuk a sima kakaóport és egy zacskó vaníliás cukrot.</p>

        <p>A már kihűlt tepsibe rakunk egy sütőpapírt, majd belefektetünk egy lapot. Erre mehet az egyik krém, amelyik éppen szimpatikus. Ezt elsimítjuk a tésztán, majd újabb tészta, a másik krém, végül a tetejére az utolsó lap kerül. A tetejére mázat teszünk, amely készülhet tortabevonóból, de főzhetjük mi magunk is cukorból, kakaóporból és vízből (10 dkg cukrot 2 evőkanál kakaóporral és kevés vízzel addig főzünk, míg besűrűsödik, majd egy jó darab hideg margarint vagy vajat elkeverünk benne). Ha nem szeretjük a mázat, akkor porcukrozhatjuk is.</p>

        <p>Az összeállított süteményt nem tudjuk rögtön felvágni, mert kicsit kemény, hagyni kell állni pár órát, hogy vágható legyen. Ha az állásban megpuhult, akkor tetszőleges módon felvágjuk és fogyasztható is.</p>

        </div>
    </div>

    </div>
  )
}